import Service from "../Service";
const resource = "TrackingUT/";

export default {
    list(filter, requestID) {
        return Service.post(resource + "list", filter, {
            params: { requestID }
        });
    },

    save(obj, requestID) {
        return Service.post(resource + "save", obj, {
            params: { requestID }
        });
    },

    excel(filter, requestID) {
        return Service.post(resource + "reportExcel", filter, {
            responseType: "blob",
            headers: {
                "Content-Type": "application/json"
            },
            params: { requestID: requestID }
        });
    }
};
